import { render, staticRenderFns } from "./users-invites.vue?vue&type=template&id=4bd7994a&"
import script from "./users-invites.vue?vue&type=script&lang=js&"
export * from "./users-invites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports